export const CALLBACK_PATH = '/auth/callback';

export interface LoginReturn {
  accessToken: string | null;
  refreshToken: string | null;
}

/**
 * IDHub hands the tokens over in the URL fragment, in two places: on
 * /auth/callback when the login started from this app (registered
 * redirect_uri), and on the app's own URL when the user signs in on IDHub
 * and picks this app from its application list (no redirect_uri).
 * Returns null when the page is not a return from IDHub.
 */
export function readLoginReturn(pathname: string, hash: string): LoginReturn | null {
  const fragment = new URLSearchParams(hash.replace(/^#/, ''));
  if (pathname !== CALLBACK_PATH && !fragment.has('access_token')) return null;
  return { accessToken: fragment.get('access_token'), refreshToken: fragment.get('refresh_token') };
}
